import React, { FunctionComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';

import MenuIcon from './MenuIcon';

import { MenuItemContainer } from './styles';

export interface Item {
  name: string;
  iconName: string;
  type?: string;
  isOldLink?: boolean;
  link?: string;
  location?: string;
  tag?: string;
}

export const isCurrentUrl = (path: string, location: string = '') => location.includes(path);

const renderItem = (props: {
  link: string;
  iconName: string;
  name: string;
  location: string;
  type: string;
  tag?: string;
}) => {
  const { link = '', iconName = '', name = '', location = '', type = '', tag = '' } = props;
  return (
    <Fragment>
      <MenuItemContainer className={'menu-item-wrapper ' + (isCurrentUrl(link, location) ? 'selected' : '')}>
        <div className="menu-icon-wrapper">
          {iconName ? (
            <MenuIcon
              type={type}
              name={iconName}
              path={isCurrentUrl(link, location) ? 'menu/active' : 'menu/inactive'}
              tag={tag ? tag : undefined}
            />
          ) : null}
        </div>
        <div className="name">{name}</div>
      </MenuItemContainer>
    </Fragment>
  );
};

const MenuItem: FunctionComponent<Item> = ({
  isOldLink = 'false',
  name = '',
  link = '',
  location = '',
  iconName,
  type = '',
  tag,
}) => {
  return (
    <Fragment>
      {isOldLink ? (
        <a data-gtm={`left menu ${name.toLowerCase()}`} key={link} href={link}>
          {renderItem({ link, iconName, name, location, type, tag })}
        </a>
      ) : (
        <Link data-gtm={`left menu ${name.toLowerCase()}`} key={link} to={link}>
          {renderItem({ link, iconName, name, location, type, tag })}
        </Link>
      )}
    </Fragment>
  );
};

export default MenuItem;
